<template>
	<div class="barWrap">
		<!-- 顶部 -->
		<div class="topbar">
			<div class="leftlogo">
				<span class="adminlogo">
					<img src="../../assets/images/logo_img.jpg">
				</span>
				<div class="admintitle" style="color:#da1818;font-size:20px;">
					<!-- 	<span style="font-size: 14px;">“精诚至善 德医双馨”</span> -->
					<p style="font-size:16px;text-indent: 12px;">安徽省大中小学思政教育一体化资源平台管理端</p>
				</div>
			</div>
			<div class="rightbar">
				<span class="usericon">
					<!-- <img src="../../assets/images/upic.png" alt=""> -->
					<img v-if="img!='null' && img" :src="img" alt="">
					<img v-else src="../../assets/images/logo_img.jpg" alt="">
				</span>
				<span class="username">{{username}}</span>
				<el-button @click="fhsy" type="danger" plain>返回首页</el-button>
				<el-button @click="exitsys" type="danger" plain>退出</el-button>
				<!-- <span class="exit" @click="exitsys">退出</span> -->
			</div>
		</div>
		<div class="bottom">
			<!-- 左侧 -->

			<div class="slidebar">

				<!-- <div class="unilogo"></div> -->
				<el-scrollbar ref="scrollMenuRef" class="scrollMenuBox">
					<div class="leftbar">
						<el-menu router :default-active="$route.path" :unique-opened="true"
							class="el-menu-vertical-demo" background-color="#fff" text-color="#000"
							active-text-color="#000">
							<template v-for="(item,index) in slide_menu">
								<el-menu-item :index="item.path" v-if="!item.children ">
									<i :class="item.icon"></i>
									<span slot="title">{{item.title}}</span>
								</el-menu-item>
								<el-submenu :index="item.path" v-if="item.children ">
									<template slot="title">
										<i :class="item.icon"></i>
										<span>{{item.title}}</span>
									</template>
									<el-menu-item-group>
										<el-menu-item :index="items.path" v-for="(items,index) in item.children">
											{{items.title}}
										</el-menu-item>
									</el-menu-item-group>
								</el-submenu>
							</template>
						</el-menu>
					</div>
				</el-scrollbar>
			</div>

			<!-- 右侧 -->
			<div class="rightcontent">
				<router-view></router-view>
			</div>
		</div>
	</div>
</template>

<script>
	import store from '@/store'
	import {
		mapState
	} from 'vuex'
	import {
		userControl
	} from '@/axios'
	export default {
		data() {
			return {
				school_icon: '',
				slide_menu: [],

			}
		},
		methods: {
			// 退出系统
			exitsys() {
				var that = this;
				store.commit('exit');
				that.$router.push({
					path: '/login'
				});
			},
			fhsy() {
				window.open("http://ahdzx.gxsentu.net/index/home.html?index=1")
			}
		},
		created() {
			var that = this;
			userControl.cdlist({
				authid: that.$store.state.authid
			}).then(res => {
				that.slide_menu = res.data;
				console.log(res.data)
			})
		},
		mounted() {

		},
		computed: {
			...mapState(['username', 'img'])
		},
	}
</script>

<style>
	.barWrap {
		width: 100%;
		height: 100%;
	}

	.topbar {
		z-index: 1;
		top: 0;
		left: 0;
		width: 100%;
		padding: 0 30px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		box-sizing: border-box;
		position: fixed;
		height: 60px;
		background: #fff;
		box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
	}

	.leftlogo {
		height: 100%;
		display: flex;
		align-items: center;
	}

	.admintitle {
		font-size: 16px;
		font-weight: bold;
		color: #000000;
	}

	.adminlogo {
		width: 55px;
		display: flex;
		align-items: center;
		/* margin-right: 5px; */
	}

	.adminlogo img {
		width: 100%;
	}

	.usericon {
		display: inline-block;
		vertical-align: middle;
		width: 32px;
		height: 32px;
		border-radius: 50%;
		margin-right: 12px;
	}

	.usericon img {
		width: 32px;
		height: 32px;
		border-radius: 50%;
	}

	.username {
		color: #333333;
		font-size: 16px;
		margin-right: 46px;
	}

	.exit {
		display: inline-block;
		vertical-align: middle;
		cursor: pointer;
		height: 32px;
		width: 90px;
		background: #E00B0B;
		line-height: 32px;
		text-align: center;
		color: #fff;
	}

	.bottom {
		width: 100%;
		height: 100%;
		/* position: fixed; */
		top: 0;
		display: flex;
		justify-content: space-between;
		left: 0;
		padding-top: 60px;
		box-sizing: border-box;
	}

	.slidebar {
		width: 12%;
		height: 100%;
		background: #fff;
		box-shadow: 2px 0px 4px 0px rgba(0, 0, 0, 0.1);
	}

	.scrollMenuBox {
		height: 100%
	}

	.el-scrollbar__wrap {
		overflow-x: hidden !important;
	}

	.unilogo {
		width: 80%;
		height: 45px;
		margin: 30px auto;
		background: url(../../assets/images/unilogo.png) no-repeat;
		background-size: 100% 100%;
	}

	.rightcontent {
		margin: 16px;
		flex: 1;
		height: 96.5%;
		min-width: 80%;
	}

	.leftbar .el-submenu__title.is-active {
		background: #F2F4FA !important;
		font-weight: bold !important;
	}

	.leftbar .el-menu-item.is-active {
		background: #F2F4FA !important;
		font-weight: bold !important;
	}
</style>
